const GET_REPEATING_BOOKINGS = 'booking/getreapeatingbookingsvue/';
module.exports = {
    getRepeatingBookings: function(id) {
        return window.axios.get(GET_REPEATING_BOOKINGS + id, { params : {}});
    },
}